import { privateApi } from 'services/Api/ApiService';
import {
    CreateTalentCustomFieldDefinition,
    TalentCustomFieldDefinition,
    UpdateTalentCustomFieldDefinition,
} from './types';

const fetchTalentCustomFieldsDefinition = (businessAccountId: string): Promise<TalentCustomFieldDefinition[]> =>
    privateApi.get<TalentCustomFieldDefinition[]>(
        `business-accounts/${businessAccountId}/leads/custom-field-definitions`,
    );

const createTalentCustomFieldDefinition = (
    businessAccountId: string,
    fieldDefinition: CreateTalentCustomFieldDefinition,
): Promise<TalentCustomFieldDefinition> =>
    privateApi.post<TalentCustomFieldDefinition>(
        `business-accounts/${businessAccountId}/leads/custom-field-definitions`,
        fieldDefinition,
    );

const updateTalentCustomFieldDefinition = (
    businessAccountId: string,
    id: string,
    fieldDefinition: UpdateTalentCustomFieldDefinition,
): Promise<void> =>
    privateApi.put<void>(
        `business-accounts/${businessAccountId}/leads/custom-field-definitions/${id}`,
        fieldDefinition,
    );

export const TalentCustomFieldsDefinitionGateway = {
    fetchTalentCustomFieldsDefinition,
    createTalentCustomFieldDefinition,
    updateTalentCustomFieldDefinition,
};
